import React from "react";
import { Brand } from "./Logo";
import MaraFooter from "./MaraFooter";

/**
 * Shared shell for every auth screen (login, forgot, set/reset/change password).
 *
 * IMPORTANTE: NON avvolgere in <form>. Ogni pagina auth include già il proprio
 * <form> interno con onSubmit. Un <form> outer qui creerebbe un nested form
 * (HTML illegale) che il browser collassa, staccando l'onSubmit interno e
 * causando in prod un native submit GET → URL `/set-password?` con query vuota.
 * Il wrapper è ora un <div> puro; il form vive solo nel figlio.
 */
export default function AuthCard({ title, subtitle, children, testId }) {
    return (
        <div
            className="min-h-screen w-full flex flex-col animate-fade-up"
            data-testid={testId || "auth-shell"}
        >
            <div className="flex-1 w-full flex items-center justify-center">
                <div className="el-card" data-testid="auth-card">
                    <Brand />
                    <h1 className="el-h1">{title}</h1>
                    {subtitle ? <p className="el-sub">{subtitle}</p> : null}
                    {children}
                </div>
            </div>
            <MaraFooter />
        </div>
    );
}
